import { render, staticRenderFns } from "./appInformation.vue?vue&type=template&id=2bf880f2&scoped=true"
import script from "./appInformation.vue?vue&type=script&lang=js"
export * from "./appInformation.vue?vue&type=script&lang=js"
import style0 from "./appInformation.vue?vue&type=style&index=0&id=2bf880f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf880f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf880f2')) {
      api.createRecord('2bf880f2', component.options)
    } else {
      api.reload('2bf880f2', component.options)
    }
    module.hot.accept("./appInformation.vue?vue&type=template&id=2bf880f2&scoped=true", function () {
      api.rerender('2bf880f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/creatApp/appInformation.vue"
export default component.exports